// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-like {
  padding-top: 0.2rem;
}

.print-pane {
    border: 1px solid #ccc;
}

.print-pane {
    background-color: #fff;
    float: left;
    padding: 20px;
    width: 100%;
}

.print-pane {
    float: none !important;
}

.report-dashboard {
    height: auto !important;
}

.report-layout-area.row-fluid {
    width: 100% !Important;
}

.report-layout-area {
    background-color: #fff;
}

.report-layout-area {
    padding-left: 0px;
    float: left;
    padding-top: 0;
    padding-bottom: 0;
    width: 975px;
    overflow: hidden;
    display: block !important;
}

.sortDash {
    border: 0;
    min-height: 0px !important;
    padding: 0px;
    padding-bottom: 10px;
}

.connectedSortable {
    background: white !important;
}

.connectedSortable .section {
    margin-bottom: 20px;
    background: #FFF;
    padding: 0px 0px 15px 0;
    border-radius: 2px;
    position: relative;
}

.sortable .handle, .sortabletitle-section .handle {
    padding: 15px 0 0 0;
}

.section .sectionBody {
    background: transparent;
    padding: 0;
}

.report-image-block-4152175 {
    width: 100%;
}

.report-header.facebook, .change-container.facebook, .change-container.facebook strong {
    background: #3b5998 !important;
    color: white !important;
}

.report-header.well {
    color: #232436;
    padding: 30px 30px 40px 30px;
    width: auto;
    margin: 10px 0;
    border-radius: 15px;
}

.report-header {
    width: 100%;
    display: block;
    position: relative;
    float: left;
    background-color: #ffffff;
    z-index: 0;
}

.report-header {
    float: none !important;
}

.report-header h2, .report-header .report-summary h6, .report-header .report-summary p {
    color: #FFFFFF !important;
}

.report-header h2 {
    color: white;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -.5px;
    margin: -12px 0 4px 0;
    text-transform: capitalize;
}

.report-header .header-container {
    display: inline-block;
    width: 100%;
    position: relative;
}

.report-header .report-profiles {
    float: left;
    width: 126px;
    height: 126px;
    margin-right: 3.5%;
    background-size: 100%;
}

.report-header .report-summary {
    display: inline-block;
    float: left;
    border-left: 1px solid rgba(255,255,255, .2);
    min-height: 130px;
    padding: 0 3.5%;
    box-sizing: border-box;
}

.report-header .report-summary i {
    color: rgba(255,255,255,.2) !important;
}

.report-header .report-summary i {
    font-size: 52px;
    color: rgba(255,255,255,.2);
    margin: -5px 0 10px 0;
}

.report-header h2, .report-header .report-summary h6, .report-header .report-summary p {
    color: #FFFFFF !important;
}

.report-header .report-summary h6 {
    margin: 0;
    font-size: 12px;
    color: #FFFFFF;
    text-transform: uppercase;
    font-weight: 300;
}

.report-header h2, .report-header .report-summary h6, .report-header .report-summary p {
    color: #FFFFFF !important;
}

.titleImg{
    background: #7165A9;
    text-align: center;
    width: 85px;
    height: 85px;
    color: #fff;
    font-size: 55px;
    line-height: 85px;
}

.title{
    font-size: 45px;
    margin-left: 20px;
    line-height: 85px;
}

.imageHolder{
    overflow: auto;
    border-bottom: 1px solid #ddd;
    padding-bottom: 20px;
}

.report-header .module-icon {
    color: white;
    font-size: 24px;
    position: absolute;
    right: 0;
    bottom: 0;
}

.report-header .report-summary p {
    font-size: 21px;
}

.share-icon {
    background: url(/assets/images/share-icon.png) no-repeat 0 0;
    width: 24px;
    height: 23px;
    display: inline-block;
    margin: 0 5px;
    min-width: 24px;
}














/********************New CSS*********************/

.tab-panel-wrap .nav.nav-tabs .nav-link { background: #303E4E; padding: 0 16px; border: none; line-height: 44px; color: #fff; text-decoration: underline; font-size: 15px; font-weight: 600; margin-right: 5px; border-radius: 5px 5px 0 0; }
.tab-panel-wrap .nav-tabs { border-bottom: none; }
.tab-panel-wrap .nav-tabs .nav-item.show .nav-link, .tab-panel-wrap .nav-tabs .nav-link.active, .tab-panel-wrap .nav-tabs .nav-link:hover { border: none; background: #F5F6FA; color: #525252; text-decoration: none; }
.tab-panel-wrap .nav-tabs .nav-item { margin-bottom: 0; }
.panel-content .panel-heading { background: #F5F6FA; padding: 35px 25px; margin-bottom: 30px; }
.panel-heading h3 { font-size: 28px; font-weight: bold; }
.panel-heading h3 span { font-weight: 400; }
.panel-heading ul.page-navigation li { display: inline-block; }
.panel-heading ul.page-navigation li a { padding: 2px 18px; border-right: #707070 solid 1px; font-weight:600; font-size: 15px; color: #4296F7; text-decoration: underline; }
.panel-heading ul.page-navigation li:last-child a { border-right: none; }
.panel-heading ul.page-navigation li:hover a, .panel-heading ul.page-navigation li.active a { color: #525252; text-decoration: none; }
.panel-content .filter-by { display: flex; justify-content: space-between; margin-bottom: 15px; }
.filter-by .date { font-size: 18px; }
.filter-by .date .fa.fa-angle-down{margin:0 0 0 5px;}
.filter-by .date .fa.fa-angle-down{font-weight:bold;}
.filter-by .date label { color: #2699FB; padding: 0 0 0 4px; text-decoration: underline; }
.filter-by .cat-list, .sort-by { font-size: 16px; position: relative; }
.filter-by .cat-list label, .sort-by label { padding: 0 7px; text-decoration: underline; cursor: pointer; }
.filter-by .cat-list .fa.fa-sort-desc, .sort-by .fa.fa-sort-desc { color: #C2C3C7; font-size: 24px; }
.filter-by .cat-list a:hover, .sort-by a:hover { text-decoration: none; }

/**********************post page css******************************/
.post-date p {
  color: rgb(000, 000, 000);
  margin-bottom: unset;
}
.post-list{border-bottom:#C6C6C6 solid 1px; margin-bottom:24px; padding-bottom:24px;}
.post-list:last-child{margin-bottom:0; border-bottom:none; padding-bottom:0;}
.post-list .post-image{max-width: 96px;
    flex-basis: 96px;
    max-height: 100px;
    border: #fff solid 3px;
    overflow: hidden;
    box-shadow: 0px 0px 1px #ccc;     align-self: center;     height: auto;}
    .post-list .post-image img{
        max-width: 100%;
    }
.post-list .post-info{padding-left:22px;}
.post-list .post-date{font-size:20px; font-weight:600; color:#4296F7; text-decoration:underline; margin-bottom:10px;}
.post-list .post-text{color:#4D4F5C; font-size:18px; margin-bottom:12px;}
.post-list .comment-like {font-size:16px; font-weight:600;}
.post-list .comment-like span{padding:0 15px 0 0; margin-right:11px; display:inline-block; color:#7C7D86; font-weight:400;}
.post-list .comment-like span{border-right:#7C7D86 solid 1px;}
.post-list .comment-like span:last-child{border-right:none;}
.panel-content .listing { margin-bottom: 25px; }
.listing-heading { background: #303E4E; height: 57px; }
.listing .listing-heading h3 { font-size: 24px; color: #fff; line-height: 57px; padding: 0 27px; }
.listing .listing-heading h3 span { font-size: 20px; }
.listing .listing-heading h3 a { color: #fff; }
.listing .list-content { padding: 25px; }
.listing-heading a.collapsed .drop-icon, .listing-heading .drop-icon { background: url(/assets/images/collapse-arrow.svg) no-repeat 0 0; width: 9px; height: 12px; display: inline-block; margin-left: 7px; transition: all 0.5s; transform: rotate(0deg); }
.listing-heading .drop-icon { width: 9px; height: 13px; transform: rotate(90deg); }
.listing .stapper { display: flex; margin-bottom: 10px; }
.listing .stapper .steps { flex-basis: 24%; display: flex; }
.graph-section.number-section .graph-box { min-height: auto; }
.graph.search-no .search-all-result { margin-bottom: 40px; }
.graph.search-no .search-all-result label { font-size: 22px; margin-bottom: 10px; }
.graph.search-no .digit { font-size: 55px; font-weight: 900; line-height: 55px; }
.individual-search label, .number-section label { font-size: 20px; margin-bottom: 7px; }
.individual-search .individual-digit { font-size: 34px; font-weight: 900; }
.number-section .digit { font-size: 50px; line-height: 50px; font-weight: 900; }
.number-section label { margin-bottom: 14px; }
.show-less {
    background: #303E4E;
    height: 43px;
    padding: 0 25px;
}
.show-less a {
    color: #fff;
    text-decoration: underline;
    line-height: 43px;
}
.select-aud-source{
    border:none; outline:none; -webkit-appearance: none; -moz-appearance: none; background: url(/assets/images/grey-dropdown.svg) no-repeat right center;
    background-size: 14px; padding-right: 15px; color: #2699FB;
}

.select-aud-source option:hover{
    background: #ddd;
}


/***************table smm report********************/
.smm-wrap{width:100%; overflow:hidden;}
.smm-report-table .post-image{width:96px;}
.smm-report-table > tbody  > tr{    border-bottom: #C6C6C6 solid 1px; display: flex; align-items: flex-start;}
.smm-report-table > tbody  > tr > td{padding-bottom:15px; padding-top:15px;}
.smm-report-table > tbody  > tr:first-child > td{padding-top:0;}
.smm-report-table > tbody  > tr:last-child {border-bottom:none;}
.smm-report-table > tbody  > tr:last-child > td{padding-bottom:0;}
.smm-report-table tr {
  margin-bottom: 1rem;
}
.smm-report-table .thumb-image{width:100px; border:#C6C6C6 solid 1px; padding:3px;   height: 100px;}
.smm-report-table .thumb-image img{width:100%; height:100%;}
.smm-report-table{font-size:20px; font-weight:600; color:#4296F7; margin-bottom:10px;}
.smm-report-table .post-text{color:#4D4F5C; font-size:18px; font-weight:400;}
.smm-report-table .post-date a{color:#4296F7; font-size:20px; font-weight:600;}
.smm-report-table .comment-like{font-size:16px; font-weight:600; color:#4D4F5C;}
.smm-report-table .comment-like span{padding:0 15px 0 0; margin-right:11px; display:inline-block; color:#7C7D86; font-weight:400;}
.smm-report-table .comment-like span{border-right:#7C7D86 solid 1px;}
/***************table smm report********************/

.pagination{
    font-size: 1rem;
}

.table-style-4 .smm-report-table .thumb-image{float:left;}
.table-style-4 tr td{padding-top: 14px;   vertical-align: top;}
.table-style-4 tr td:nth-child(3){padding-top: 0;}
`, "",{"version":3,"sources":["webpack://./src/app/components/reporting/smm-report/smm-report.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,0BAA0B;IAC1B,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IAGvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,4CAA4C;IAC5C,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4DAA4D;IAC5D,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,eAAe;AACnB;;;;;;;;;;;;;;;AAeA,iDAAiD;;AAEjD,0CAA0C,mBAAmB,EAAE,eAAe,EAAE,YAAY,EAAE,iBAAiB,EAAE,WAAW,EAAE,0BAA0B,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,0BAA0B,EAAE;AAC5O,4BAA4B,mBAAmB,EAAE;AACjD,4IAA4I,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACtN,sCAAsC,gBAAgB,EAAE;AACxD,gCAAgC,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC9F,oBAAoB,eAAe,EAAE,iBAAiB,EAAE;AACxD,yBAAyB,gBAAgB,EAAE;AAC3C,uCAAuC,qBAAqB,EAAE;AAC9D,yCAAyC,iBAAiB,EAAE,+BAA+B,EAAE,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE,0BAA0B,EAAE;AAC3K,oDAAoD,kBAAkB,EAAE;AACxE,8FAA8F,cAAc,EAAE,qBAAqB,EAAE;AACrI,4BAA4B,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AAChG,mBAAmB,eAAe,EAAE;AACpC,mCAAmC,gBAAgB,CAAC;AACpD,mCAAmC,gBAAgB,CAAC;AACpD,yBAAyB,cAAc,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACzF,iCAAiC,eAAe,EAAE,kBAAkB,EAAE;AACtE,6CAA6C,cAAc,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC1G,mEAAmE,cAAc,EAAE,eAAe,EAAE;AACpG,iDAAiD,qBAAqB,EAAE;;AAExE,kEAAkE;AAClE;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA,WAAW,+BAA+B,EAAE,kBAAkB,EAAE,mBAAmB,CAAC;AACpF,sBAAsB,eAAe,EAAE,kBAAkB,EAAE,gBAAgB,CAAC;AAC5E,uBAAuB,eAAe;IAClC,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,4BAA4B,MAAM,kBAAkB,MAAM,YAAY,CAAC;IACvE;QACI,eAAe;IACnB;AACJ,sBAAsB,iBAAiB,CAAC;AACxC,sBAAsB,cAAc,EAAE,eAAe,EAAE,aAAa,EAAE,yBAAyB,EAAE,kBAAkB,CAAC;AACpH,sBAAsB,aAAa,EAAE,cAAc,EAAE,kBAAkB,CAAC;AACxE,0BAA0B,cAAc,EAAE,eAAe,CAAC;AAC1D,8BAA8B,kBAAkB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,aAAa,EAAE,eAAe,CAAC;AAC1H,8BAA8B,8BAA8B,CAAC;AAC7D,yCAAyC,iBAAiB,CAAC;AAC3D,0BAA0B,mBAAmB,EAAE;AAC/C,mBAAmB,mBAAmB,EAAE,YAAY,EAAE;AACtD,+BAA+B,eAAe,EAAE,WAAW,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACjG,oCAAoC,eAAe,EAAE;AACrD,iCAAiC,WAAW,EAAE;AAC9C,yBAAyB,aAAa,EAAE;AACxC,uEAAuE,gEAAgE,EAAE,UAAU,EAAE,YAAY,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,uBAAuB,EAAE;AAC3P,8BAA8B,UAAU,EAAE,YAAY,EAAE,wBAAwB,EAAE;AAClF,oBAAoB,aAAa,EAAE,mBAAmB,EAAE;AACxD,2BAA2B,eAAe,EAAE,aAAa,EAAE;AAC3D,2CAA2C,gBAAgB,EAAE;AAC7D,sCAAsC,mBAAmB,EAAE;AAC3D,4CAA4C,eAAe,EAAE,mBAAmB,EAAE;AAClF,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAChF,kDAAkD,eAAe,EAAE,kBAAkB,EAAE;AACvF,uCAAuC,eAAe,EAAE,gBAAgB,EAAE;AAC1E,yBAAyB,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC/E,wBAAwB,mBAAmB,EAAE;AAC7C;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,WAAW,EAAE,YAAY,EAAE,wBAAwB,EAAE,qBAAqB,EAAE,wEAAwE;IACpJ,qBAAqB,EAAE,mBAAmB,EAAE,cAAc;AAC9D;;AAEA;IACI,gBAAgB;AACpB;;;AAGA,oDAAoD;AACpD,UAAU,UAAU,EAAE,eAAe,CAAC;AACtC,8BAA8B,UAAU,CAAC;AACzC,oCAAoC,gCAAgC,EAAE,aAAa,EAAE,uBAAuB,CAAC;AAC7G,qCAAqC,mBAAmB,EAAE,gBAAgB,CAAC;AAC3E,iDAAiD,aAAa,CAAC;AAC/D,4CAA4C,kBAAkB,CAAC;AAC/D,gDAAgD,gBAAgB,CAAC;AACjE;EACE,mBAAmB;AACrB;AACA,+BAA+B,WAAW,EAAE,wBAAwB,EAAE,WAAW,IAAI,aAAa,CAAC;AACnG,mCAAmC,UAAU,EAAE,WAAW,CAAC;AAC3D,kBAAkB,cAAc,EAAE,eAAe,EAAE,aAAa,EAAE,kBAAkB,CAAC;AACrF,6BAA6B,aAAa,EAAE,cAAc,EAAE,eAAe,CAAC;AAC5E,+BAA+B,aAAa,EAAE,cAAc,EAAE,eAAe,CAAC;AAC9E,gCAAgC,cAAc,EAAE,eAAe,EAAE,aAAa,CAAC;AAC/E,qCAAqC,kBAAkB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,aAAa,EAAE,eAAe,CAAC;AACjI,qCAAqC,8BAA8B,CAAC;AACpE,oDAAoD;;AAEpD;IACI,eAAe;AACnB;;AAEA,8CAA8C,UAAU,CAAC;AACzD,qBAAqB,iBAAiB,IAAI,mBAAmB,CAAC;AAC9D,kCAAkC,cAAc,CAAC","sourcesContent":[".comment-like {\n  padding-top: 0.2rem;\n}\n\n.print-pane {\n    border: 1px solid #ccc;\n}\n\n.print-pane {\n    background-color: #fff;\n    float: left;\n    padding: 20px;\n    width: 100%;\n}\n\n.print-pane {\n    float: none !important;\n}\n\n.report-dashboard {\n    height: auto !important;\n}\n\n.report-layout-area.row-fluid {\n    width: 100% !Important;\n}\n\n.report-layout-area {\n    background-color: #fff;\n}\n\n.report-layout-area {\n    padding-left: 0px;\n    float: left;\n    padding-top: 0;\n    padding-bottom: 0;\n    width: 975px;\n    overflow: hidden;\n    display: block !important;\n}\n\n.sortDash {\n    border: 0;\n    min-height: 0px !important;\n    padding: 0px;\n    padding-bottom: 10px;\n}\n\n.connectedSortable {\n    background: white !important;\n}\n\n.connectedSortable .section {\n    margin-bottom: 20px;\n    background: #FFF;\n    padding: 0px 0px 15px 0;\n    -webkit-border-radius: 2px;\n    -moz-border-radius: 2px;\n    border-radius: 2px;\n    position: relative;\n}\n\n.sortable .handle, .sortabletitle-section .handle {\n    padding: 15px 0 0 0;\n}\n\n.section .sectionBody {\n    background: transparent;\n    padding: 0;\n}\n\n.report-image-block-4152175 {\n    width: 100%;\n}\n\n.report-header.facebook, .change-container.facebook, .change-container.facebook strong {\n    background: #3b5998 !important;\n    color: white !important;\n}\n\n.report-header.well {\n    color: #232436;\n    padding: 30px 30px 40px 30px;\n    width: auto;\n    margin: 10px 0;\n    border-radius: 15px;\n}\n\n.report-header {\n    width: 100%;\n    display: block;\n    position: relative;\n    float: left;\n    background-color: #ffffff;\n    z-index: 0;\n}\n\n.report-header {\n    float: none !important;\n}\n\n.report-header h2, .report-header .report-summary h6, .report-header .report-summary p {\n    color: #FFFFFF !important;\n}\n\n.report-header h2 {\n    color: white;\n    font-size: 22px;\n    font-weight: 700;\n    letter-spacing: -.5px;\n    margin: -12px 0 4px 0;\n    text-transform: capitalize;\n}\n\n.report-header .header-container {\n    display: inline-block;\n    width: 100%;\n    position: relative;\n}\n\n.report-header .report-profiles {\n    float: left;\n    width: 126px;\n    height: 126px;\n    margin-right: 3.5%;\n    background-size: 100%;\n}\n\n.report-header .report-summary {\n    display: inline-block;\n    float: left;\n    border-left: 1px solid rgba(255,255,255, .2);\n    min-height: 130px;\n    padding: 0 3.5%;\n    box-sizing: border-box;\n}\n\n.report-header .report-summary i {\n    color: rgba(255,255,255,.2) !important;\n}\n\n.report-header .report-summary i {\n    font-size: 52px;\n    color: rgba(255,255,255,.2);\n    margin: -5px 0 10px 0;\n}\n\n.report-header h2, .report-header .report-summary h6, .report-header .report-summary p {\n    color: #FFFFFF !important;\n}\n\n.report-header .report-summary h6 {\n    margin: 0;\n    font-size: 12px;\n    color: #FFFFFF;\n    text-transform: uppercase;\n    font-weight: 300;\n}\n\n.report-header h2, .report-header .report-summary h6, .report-header .report-summary p {\n    color: #FFFFFF !important;\n}\n\n.titleImg{\n    background: #7165A9;\n    text-align: center;\n    width: 85px;\n    height: 85px;\n    color: #fff;\n    font-size: 55px;\n    line-height: 85px;\n}\n\n.title{\n    font-size: 45px;\n    margin-left: 20px;\n    line-height: 85px;\n}\n\n.imageHolder{\n    overflow: auto;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 20px;\n}\n\n.report-header .module-icon {\n    color: white;\n    font-size: 24px;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n\n.report-header .report-summary p {\n    font-size: 21px;\n}\n\n.share-icon {\n    background: url(/assets/images/share-icon.png) no-repeat 0 0;\n    width: 24px;\n    height: 23px;\n    display: inline-block;\n    margin: 0 5px;\n    min-width: 24px;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/********************New CSS*********************/\n\n.tab-panel-wrap .nav.nav-tabs .nav-link { background: #303E4E; padding: 0 16px; border: none; line-height: 44px; color: #fff; text-decoration: underline; font-size: 15px; font-weight: 600; margin-right: 5px; border-radius: 5px 5px 0 0; }\n.tab-panel-wrap .nav-tabs { border-bottom: none; }\n.tab-panel-wrap .nav-tabs .nav-item.show .nav-link, .tab-panel-wrap .nav-tabs .nav-link.active, .tab-panel-wrap .nav-tabs .nav-link:hover { border: none; background: #F5F6FA; color: #525252; text-decoration: none; }\n.tab-panel-wrap .nav-tabs .nav-item { margin-bottom: 0; }\n.panel-content .panel-heading { background: #F5F6FA; padding: 35px 25px; margin-bottom: 30px; }\n.panel-heading h3 { font-size: 28px; font-weight: bold; }\n.panel-heading h3 span { font-weight: 400; }\n.panel-heading ul.page-navigation li { display: inline-block; }\n.panel-heading ul.page-navigation li a { padding: 2px 18px; border-right: #707070 solid 1px; font-weight:600; font-size: 15px; color: #4296F7; text-decoration: underline; }\n.panel-heading ul.page-navigation li:last-child a { border-right: none; }\n.panel-heading ul.page-navigation li:hover a, .panel-heading ul.page-navigation li.active a { color: #525252; text-decoration: none; }\n.panel-content .filter-by { display: flex; justify-content: space-between; margin-bottom: 15px; }\n.filter-by .date { font-size: 18px; }\n.filter-by .date .fa.fa-angle-down{margin:0 0 0 5px;}\n.filter-by .date .fa.fa-angle-down{font-weight:bold;}\n.filter-by .date label { color: #2699FB; padding: 0 0 0 4px; text-decoration: underline; }\n.filter-by .cat-list, .sort-by { font-size: 16px; position: relative; }\n.filter-by .cat-list label, .sort-by label { padding: 0 7px; text-decoration: underline; cursor: pointer; }\n.filter-by .cat-list .fa.fa-sort-desc, .sort-by .fa.fa-sort-desc { color: #C2C3C7; font-size: 24px; }\n.filter-by .cat-list a:hover, .sort-by a:hover { text-decoration: none; }\n\n/**********************post page css******************************/\n.post-date p {\n  color: rgb(000, 000, 000);\n  margin-bottom: unset;\n}\n.post-list{border-bottom:#C6C6C6 solid 1px; margin-bottom:24px; padding-bottom:24px;}\n.post-list:last-child{margin-bottom:0; border-bottom:none; padding-bottom:0;}\n.post-list .post-image{max-width: 96px;\n    flex-basis: 96px;\n    max-height: 100px;\n    border: #fff solid 3px;\n    overflow: hidden;\n    box-shadow: 0px 0px 1px #ccc;     align-self: center;     height: auto;}\n    .post-list .post-image img{\n        max-width: 100%;\n    }\n.post-list .post-info{padding-left:22px;}\n.post-list .post-date{font-size:20px; font-weight:600; color:#4296F7; text-decoration:underline; margin-bottom:10px;}\n.post-list .post-text{color:#4D4F5C; font-size:18px; margin-bottom:12px;}\n.post-list .comment-like {font-size:16px; font-weight:600;}\n.post-list .comment-like span{padding:0 15px 0 0; margin-right:11px; display:inline-block; color:#7C7D86; font-weight:400;}\n.post-list .comment-like span{border-right:#7C7D86 solid 1px;}\n.post-list .comment-like span:last-child{border-right:none;}\n.panel-content .listing { margin-bottom: 25px; }\n.listing-heading { background: #303E4E; height: 57px; }\n.listing .listing-heading h3 { font-size: 24px; color: #fff; line-height: 57px; padding: 0 27px; }\n.listing .listing-heading h3 span { font-size: 20px; }\n.listing .listing-heading h3 a { color: #fff; }\n.listing .list-content { padding: 25px; }\n.listing-heading a.collapsed .drop-icon, .listing-heading .drop-icon { background: url(/assets/images/collapse-arrow.svg) no-repeat 0 0; width: 9px; height: 12px; display: inline-block; margin-left: 7px; transition: all 0.5s; transform: rotate(0deg); }\n.listing-heading .drop-icon { width: 9px; height: 13px; transform: rotate(90deg); }\n.listing .stapper { display: flex; margin-bottom: 10px; }\n.listing .stapper .steps { flex-basis: 24%; display: flex; }\n.graph-section.number-section .graph-box { min-height: auto; }\n.graph.search-no .search-all-result { margin-bottom: 40px; }\n.graph.search-no .search-all-result label { font-size: 22px; margin-bottom: 10px; }\n.graph.search-no .digit { font-size: 55px; font-weight: 900; line-height: 55px; }\n.individual-search label, .number-section label { font-size: 20px; margin-bottom: 7px; }\n.individual-search .individual-digit { font-size: 34px; font-weight: 900; }\n.number-section .digit { font-size: 50px; line-height: 50px; font-weight: 900; }\n.number-section label { margin-bottom: 14px; }\n.show-less {\n    background: #303E4E;\n    height: 43px;\n    padding: 0 25px;\n}\n.show-less a {\n    color: #fff;\n    text-decoration: underline;\n    line-height: 43px;\n}\n.select-aud-source{\n    border:none; outline:none; -webkit-appearance: none; -moz-appearance: none; background: url(/assets/images/grey-dropdown.svg) no-repeat right center;\n    background-size: 14px; padding-right: 15px; color: #2699FB;\n}\n\n.select-aud-source option:hover{\n    background: #ddd;\n}\n\n\n/***************table smm report********************/\n.smm-wrap{width:100%; overflow:hidden;}\n.smm-report-table .post-image{width:96px;}\n.smm-report-table > tbody  > tr{    border-bottom: #C6C6C6 solid 1px; display: flex; align-items: flex-start;}\n.smm-report-table > tbody  > tr > td{padding-bottom:15px; padding-top:15px;}\n.smm-report-table > tbody  > tr:first-child > td{padding-top:0;}\n.smm-report-table > tbody  > tr:last-child {border-bottom:none;}\n.smm-report-table > tbody  > tr:last-child > td{padding-bottom:0;}\n.smm-report-table tr {\n  margin-bottom: 1rem;\n}\n.smm-report-table .thumb-image{width:100px; border:#C6C6C6 solid 1px; padding:3px;   height: 100px;}\n.smm-report-table .thumb-image img{width:100%; height:100%;}\n.smm-report-table{font-size:20px; font-weight:600; color:#4296F7; margin-bottom:10px;}\n.smm-report-table .post-text{color:#4D4F5C; font-size:18px; font-weight:400;}\n.smm-report-table .post-date a{color:#4296F7; font-size:20px; font-weight:600;}\n.smm-report-table .comment-like{font-size:16px; font-weight:600; color:#4D4F5C;}\n.smm-report-table .comment-like span{padding:0 15px 0 0; margin-right:11px; display:inline-block; color:#7C7D86; font-weight:400;}\n.smm-report-table .comment-like span{border-right:#7C7D86 solid 1px;}\n/***************table smm report********************/\n\n.pagination{\n    font-size: 1rem;\n}\n\n.table-style-4 .smm-report-table .thumb-image{float:left;}\n.table-style-4 tr td{padding-top: 14px;   vertical-align: top;}\n.table-style-4 tr td:nth-child(3){padding-top: 0;}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
